import axiosInstance from "./AxiosInstance";

export function getLocationOptionApi() {
  return axiosInstance.get(`/api/setting/location/`);
}
export function createLocationApi(data) {
  return axiosInstance.post(`/api/setting/location/`, data);
}
export function searchcategoryOptionApi() {
  return axiosInstance.get(`/api/asset-category/`);
}
export function searchcAssetOptionApi() {
  return axiosInstance.get("api/search/asset");
}
export function searchVendorOptionApi() {
  return axiosInstance.get("api/search/vendor");
}
export function searchDepartmentOptionApi() {
  return axiosInstance.get("api/search/department");
}
export function searchAreaByDepartmentApi(departmentId) {
  return axiosInstance.get(`api/search/area/${departmentId}`);
}
export function searchAreaByLocationApi(locationId) {
  return axiosInstance.get(`api/search/area-by-location/${locationId}`);
}
export function SearchDepartmentByLocationApi(locationId) {
  return axiosInstance.get(`api/search/department/${locationId}`);
}
export function SearchAreaApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/search/area?${fparam}`);
}
export function SearchLocationApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/search/location?${fparam}`);
}
export function SearchAuditorsApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/search/auditors?${fparam}`);
}

export function searchAuditorBySession(sessionId) {
  return axiosInstance.get(`api/search/auditors/audit-sessions/${sessionId}/`);
}

export function SearchDepartmentBySessionIdApi(sessionId) {
  return axiosInstance.get(
    `api/audit/audit-sessions-departments/${sessionId}/`
  );
}


export function SearchUserAreasApi(param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`api/search/user/areas/?${fparam}`);
}



